export default "__VITE_PUBLIC_ASSET__e5a62205__"